import { useEffect, useState } from "react";


import CaptureGuide from "./screens/captureguide";
import FaceCaptureStep from "./screens/facecapturestep";
import PhotoPreviewScreen from "./screens/previewscreen";
import SubmitSuccessScreen from "./screens/submitstatus";

import { Backdrop, CircularProgress } from "@mui/material"; 
import { useLocation, useNavigate } from "react-router-dom";

import { useSelector } from "react-redux";
import SideNavLayout from "../../customsidenav/sidenavlayout";
import api from "../../api/api";
import ToastMessage from "../../utils/mui/righttoptoast";
import UserDetailsForm from "./screens/company";
import { use } from "react";
import dayjs from "dayjs";

const FacialRecognization= () => {
  const [screen, setScreen] = useState(1);
    const practiseid = window.getPracticeId();

 const userConfig = useSelector((state) => state.userconfig);
const navigate=useNavigate()
const location = useLocation();
const queryParams = new URLSearchParams(location.search)
 const [openToast, setOpenToast] = useState(false); // Toast visibility
  const [toastMessage, setToastMessage] = useState(''); // Message to show in Toast
  const [toastSeverity, setToastSeverity] = useState('error'); 
    const [userData, setUserData] = useState({
      username: "",
      email: "",
      phone: "",
      dob: null,
    });

   const user = useSelector((state) => state.user?.userDetails);
  const [photos, setPhotos] = useState({
    Front: null,
    Left: null,
    Right: null,
    Up: null,
    Down: null,
  });
    const handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
 setOpenToast(false);
  };
const[queryid,setqueryid]=useState('')
  const [loading, setLoading] = useState(false);
  const [capturedSteps, setCapturedSteps] = useState([]);
  const [currentStep, setCurrentStep] = useState(0);
 
const reset=()=>{
setUserData({
      username: "",
      email: "",
      phone: "",
      dob: null,
    })
   setCurrentStep(0)

    setCapturedSteps([])
  
        setPhotos({
    Front: null,
    Left: null,
    Right: null,
    Up: null,
    Down: null,
  })
    
}

useEffect(() => {
  const username = queryParams.get("username");
  const email = queryParams.get("email");
  const phone = queryParams.get("phone");
   const userid = queryParams.get("userid");

  if (username && email && phone) {
    setUserData({ username, email, phone, dob: null });
    setqueryid(userid)
  
    console.log(queryParams.get("userid"))
  }
  if (userid) {
  const fetchOnboardStatus = async () => {
    try {
      const response = await api.get(`/v1/${practiseid}/onboarding-employee/${userid}`);
      if (response.status === 200) {
        setScreen(5); // Already completed setup
      }
    } catch (error) {
      console.log("No previous onboarding found, continuing...");
    }
  };
  fetchOnboardStatus();
}


  setUserData((prev) => ({ ...prev, onboarduser: userid || null }));
}, [location.search])

const submit = async () => {

  try {
    setLoading(true);

    // Convert photos object into array of base64 strings (skip nulls)
   const photoBase64Array = Object.values(photos)
  .filter(Boolean)
  .map((img) => img.replace(/^data:image\/\w+;base64,/, ""));


    const response = await api.post(`/v1/${practiseid}/onboarding-employee`, {
      employee_details: {       
       emp_name: userData?.username || "",
      email:userData?.email,
      phone:userData?.phone,
      dob:userData?.dob,
  emp_id:queryid 
      },
      employee_images: photoBase64Array,
      created_by: userConfig.username,
 
    });

    if (response.status === 200 ) {
      if(queryid){
            await api.put(`/v1/${practiseid}/user/config`, {
                "rowid":queryid,
  "enrolled_id":response.data.enrolled_id,
    "hire_date": dayjs().format("YYYY-MM-DD")
            });
      }
      setToastMessage("Employee onboarded successfully!");
      setToastSeverity("success");
      setOpenToast(true);
      reset()
      setScreen(4); // go to success screen
      if(queryid){
setTimeout(() => navigate('/user'), 1200);
      }



    } else {
      setToastMessage(response?.message||"Failed to onboard employee. Please try again.");
      setToastSeverity("error");
      setOpenToast(true);
    }
  } catch (error) {
    console.error("Onboarding error:", error);
    setToastMessage("Something went wrong. Please try again.");
    setToastSeverity("error");
    setOpenToast(true);
  } finally {
    setLoading(false);
    //  window.location.reload();
  }
};

  const renderScreen = () => {
    switch (screen) {
//       case 0:
//         return (
//           <UserDetailsForm
//  formData={userData}
//  setFormData={setUserData}
//             setScreen={setScreen}
      
//           />
//         );
      case 1:
        return (
          <CaptureGuide
   setScreen={setScreen}

          />
        );
      case 2:
        return (
          <FaceCaptureStep
            key={JSON.stringify(photos)}
          
            setScreen={setScreen}
            photos={photos}
            setPhotos={setPhotos}
            capturedSteps={capturedSteps}
            setCapturedSteps={setCapturedSteps}
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
          />
        );
       case 3:
  return (
    <PhotoPreviewScreen
  
    submit={submit}
     setPhotos={setPhotos} 
      photos={photos}
      setScreen={setScreen}
      setCurrentStep={setCurrentStep}
      setCapturedSteps={setCapturedSteps}
      reset={reset}
         
    />
  ); 
  case 4:
  return (
    <SubmitSuccessScreen
    userData={userData}
      setScreen={setScreen}

    />
  );
case 5:
  return (
    <div className="flex flex-col items-center justify-center min-h-[70vh] text-center bg-white shadow-md rounded-2xl p-10 mx-4">
      <div className="flex flex-col items-center gap-4">
        <div className="bg-green-100 p-4 rounded-full">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="green"
            className="w-12 h-12"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <h2 className="text-2xl font-bold text-gray-800">
          Facial Recognition Already Completed
        </h2>
        <p className="text-gray-500 max-w-md">
          This employee has already completed the facial recognition setup.  
          You can review user details or return to the user list.
        </p>
        <button
          onClick={() => navigate('/user')}
          className="mt-6 px-6 py-2.5 bg-blue-600 text-white text-sm font-medium rounded-lg shadow-md hover:bg-blue-700 transition-all duration-200"
        >
          ← Back to Users
        </button>
      </div>
    </div>
  );

      default:
        return <div>No screen found</div>;
    }
  };

  return (
       <div className="h-full overflow-auto custom-scrollbar">
      <SideNavLayout>
        <div className="flex justify-center items-center min-h-[80vh] w-full">
          {renderScreen()}
        </div>
      </SideNavLayout>
<ToastMessage
        message={toastMessage} 
        severity={toastSeverity} 
        open={openToast} 
        handleClose={handleCloseToast} 
      />

        
     
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default FacialRecognization;